import { render } from "./PlayoutDestination.vue?vue&type=template&id=7699d10a"
import script from "./PlayoutDestination.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayoutDestination.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/TVPlayout/PlayoutDestination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7699d10a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7699d10a', __exports__)) {
    api.reload('7699d10a', __exports__)
  }
  
  module.hot.accept("./PlayoutDestination.vue?vue&type=template&id=7699d10a", () => {
    api.rerender('7699d10a', render)
  })

}


export default __exports__